import { isEnvVarEnabled } from '../lib/utils/env-variables/isEnvVarEnabled';
import { isNonEmptyEnvVar } from '../lib/utils/env-variables/isNonEmptyEnvVar';

export const isStageEnvironment = process.env.REACT_APP_ENVIRONMENT === 'stage';
export const isProductionEnvironment = process.env.REACT_APP_ENVIRONMENT === 'prod';

/**
 * Selects the KCC AppLayout shell on non-prod by default.
 * Prod keeps the legacy shell until REACT_APP_ENABLE_NEW_APP_LAYOUT is turned on.
 * An explicit REACT_APP_ENABLE_NEW_APP_LAYOUT value always wins (for local preview of either shell).
 */
export const isNewAppLayoutEnabled = (): boolean => {
  if (isNonEmptyEnvVar(process.env.REACT_APP_ENABLE_NEW_APP_LAYOUT)) {
    return isEnvVarEnabled(process.env.REACT_APP_ENABLE_NEW_APP_LAYOUT);
  }

  return process.env.REACT_APP_ENVIRONMENT !== 'prod';
};
